<template>
    <div>
       <div  style="overflow: auto;">
           <table ref="table" border="0" class="draggable-table">
               <thead>
                   <tr>
                       <th>
                           <div class="cell">排序</div>
                       </th>
                       <th>
                           <div class="cell">序号</div>
                       </th>
                       <th>
                           <div class="cell">类型</div>
                       </th>
                       <th>
                           <div class="cell">ID</div>
                       </th>
                       <th>
                           <div class="cell">名称</div>
                       </th>
                       <th>
                           <div class="cell">上下线时间</div>
                       </th>
                       <th>
                           <div class="cell">起止时间</div>
                       </th>                      
                   </tr>
               </thead>
               <vuedraggable v-model="dataList"  tag="tbody" handle=".handle"  @change="updateWordSort">                
                   <template v-if="dataList && dataList.length > 0">
                       <tr v-for="t in dataList" :key="t.id">
                           <td>
                               <div class="cell handle">                                
                                   <i class="el-icon-sort"></i>
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                   {{ t.sort }}
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                  <!-- <p v-if="t.type == 1">膨胀红包</p>
								  <p v-else-if="t.type == 2">幸运抽奖</p>
								  <p v-else-if="t.type == 3">分享活动</p>
								  <p v-else-if="t.type == 4">解锁海报</p>
                                  <p v-else-if="t.type == 5">现场打卡</p> -->
                                  {{t.typeView}}
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                   {{ t.id }}
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                   {{t.title}}
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                   <p v-if="t.onTime">上线：{{t.onTime }}</p>
                                   <p v-if="t.offTime">下线：{{t.offTime }}</p>
                               </div>
                           </td>
                           <td>
                               <div class="cell">
                                   <p v-if="t.startTime">起：{{t.startTime }}</p>
                                   <p v-if="t.endTime">止：{{t.endTime }}</p>
                               </div>
                           </td>
                          
                       </tr>
                   </template>
                   <tr v-else class="ignore">
                       <td colspan="9">
                           <div class="empty">暂无数据</div>
                       </td>
                   </tr>
               </vuedraggable>
           </table>
       </div>
    </div>
</template>

<script>
import vuedraggable from 'vuedraggable';
export default {
    components: {
        vuedraggable
    },
    data(){
        this.defaultParams = {
            // 查询类型 1：ID 2：名称
            type: 1,
            value: null,
            // 时间类型，1：生效时间 2：截止时间
            dateType: 1,
            date: null,
            pageNo: 1,
            pageSize: this.$pageSizes[0],
            couponType: "",
        };

        return {
            data: [],
            dataList: [],
           
            listLoading: true,
           
           
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            this.listLoading = true;
            const res = await this.$request({
                url: '/event/sort/list',
                method: 'post',
                data: {}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.dataList = result;
            
        },
		updateWordSort(){
		    let data = this.dataList.map((i, idx)=>{   
		        i.sort = idx + 1;          
		        return {
		            sort: i.sort,
		            id: i.id,
					type:i.type
		        }
		    })
		    this.$request({
		        url: "/event/sort/sort",
		        method: "POST",
		        data
		    }).then((res) => {
		            const { state, msg } = res.data;
		            if (state == 1 ) {
		                this.$message.success("操作成功");
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		},
        
       
    }
}
</script>

<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>